import { API_BASE_URL } from "utils/constants";

const DocumentManagementPaths = {
  extract_file: `${API_BASE_URL}/document/gettext`,

  preview_file: `${API_BASE_URL}/document/marksect`,

  save_file: `${API_BASE_URL}/document/splittext`,

  save_chunk: `${API_BASE_URL}/document/savedb`,

  update_chunk: `${API_BASE_URL}/document/update-chunk`,

  download_file: `${API_BASE_URL}/document/download-file`,

  get_document: `${API_BASE_URL}/document/get-document?:query`,

  get_tree_document: `${API_BASE_URL}/document/tree`,

  add_document: `${API_BASE_URL}/document/add-folder-tree`,

  delete_folder_document: `${API_BASE_URL}/document/delete-folder-tree`,

  delete_file_document: `${API_BASE_URL}/document/delete-file-tree`,

  get_regex: `${API_BASE_URL}/document/getpattern`,

  add_new_crawling_url: `${API_BASE_URL}/document/add-file-tree`,
};

export default DocumentManagementPaths;
